module.exports = __webpack_public_path__ + "static/img/office_02.b3bd82f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2022/corona/office_02.png
// module id = HQdo
// module chunks = 0